/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import Lottie from 'react-lottie-player'
import SuccessAnimation from 'components/Animations/SuccessAnimation.json'
import clsx from 'clsx'
import UiAuthFormShell from 'components/Ui/UiAuthFormShell'
import UiButton, {UiButtonSize, UiButtonStyle, UiButtonType,} from 'components/Ui/UiButton'

const RecoverySuccess = () => {
    const { t } = useTranslation()
    const [accessComplete, setAccessComplete] = useState<boolean>(false)

    return (
        <UiAuthFormShell
            title={t('Password changed successfully')}
            subtitle={t(
                'Continue to login from the main page. Please, store your password in a safe place.'
            )}
        >
            <div className={clsx('flex flex-col items-center space-y-6')}>
                <div
                    className={clsx(
                        'w-24 h-24 rounded-full bg-green-50 dark:bg-green-900/20',
                        'flex items-center justify-center p-4'
                    )}
                >
                    <Lottie
                        animationData={SuccessAnimation}
                        loop={false}
						play={true}
                        onComplete={() => setAccessComplete(true)}
                        className={clsx('w-full h-full')}
                    />
                </div>

                <div
                    className={clsx(
                        'w-full transition-all duration-500 ease-in-out',
                        accessComplete
                            ? 'opacity-100 translate-y-0'
                            : 'opacity-0 translate-y-4' 
                    )}
                >
                    <div className={clsx('flex justify-center')}>
                        <Link to={'/'} className={clsx('w-full')}>
                            <UiButton
                                id={'btn-recovery-success-home'}
                                style={UiButtonStyle.Primary}
                                size={UiButtonSize.Medium}
                                type={UiButtonType.Button}
                                title={t('Back to main')}
                                className={clsx('w-full')}
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </UiAuthFormShell>
    )
}

export default RecoverySuccess
